import { render, staticRenderFns } from "./cardSetting.vue?vue&type=template&id=453d69b5&scoped=true&"
import script from "./cardSetting.vue?vue&type=script&lang=js&"
export * from "./cardSetting.vue?vue&type=script&lang=js&"
import style0 from "./cardSetting.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cardSetting.vue?vue&type=style&index=1&id=453d69b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d69b5",
  null
  
)

export default component.exports